import { Outlet, useNavigate } from 'react-router-dom';
import { useGraphAuth } from '../hooks/useGraphAuth';
import ISILogo from '../images/ISILogo.png';

function Layout() {
  const { currentUser, logout, isAuthenticated } = useGraphAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    // Navigate to home with no params (clears all filters)
    navigate('/', { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Header - Dark bar like ISI website */}
      <header className="bg-gray-700 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center h-16">
            {/* Logo - Left */}
            <a href="/" onClick={handleLogoClick} className="flex-shrink-0">
              <img src={ISILogo} alt="ISI Logo" className="h-10 w-auto" />
            </a>

            {/* Title - Center */}
            <div className="flex-1 text-center">
              <span className="text-lg font-semibold text-white">
                Operations Archive Mailbox Browser
              </span>
            </div>

            {/* User info and logout - Right */}
            {isAuthenticated && currentUser ? (
              <div className="flex items-center space-x-4 flex-shrink-0">
                <div className="text-right hidden sm:block">
                  <p className="text-sm font-medium text-white">{currentUser.name}</p>
                  <p className="text-xs text-gray-300">{currentUser.email}</p>
                </div>
                <button
                  onClick={handleLogout}
                  className="inline-flex items-center px-3 py-2 border border-gray-500 text-sm font-medium rounded-md text-gray-200 bg-gray-600 hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 focus:ring-offset-gray-700 transition-colors"
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                  Sign out
                </button>
              </div>
            ) : (
              <div className="w-32"></div>
            )}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm text-gray-500">
          ISI Claims Email Archive Browser - Internal Use Only
        </div>
      </footer>
    </div>
  );
}

export default Layout;
